import { render, staticRenderFns } from "./ModalAddProfile.vue?vue&type=template&id=39130e1c&scoped=true&"
import script from "./ModalAddProfile.vue?vue&type=script&lang=ts&"
export * from "./ModalAddProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAddProfile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalAddProfile.vue?vue&type=style&index=1&id=39130e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39130e1c",
  null
  
)

export default component.exports